module.exports = "/images/box-iocn.svg?9623d48cf5bcc76d32ace315c7eaeded";